import * as ng from 'angular';
import './ApprovalRequestsListController';
import './approvalRequestListTemplate.html';

angular.module("GorillaBoy.Approvals")
.directive('approvalRequestsList', () => {
    return {
        restrict: 'E',
        scope: {
            show : "@"
        },
        controller: 'ApprovalRequestsListController',
        templateUrl: './approvals/listRequests/approvalRequestListTemplate.html'
    };
});
